import { API_BASE } from "@/lib/utils";

/** The api a partner's backend and page call: never relative, even where the dashboard proxies it. */
export function publicApiBase(): string {
  return API_BASE.startsWith("http") ? API_BASE : window.location.origin;
}

/**
 * The iframe a partner pastes, in the form the Widgets page and the embedding guide give it.
 *
 * referrerpolicy is the SDK's own (packages/embed): it lets the frame load carry the partner's
 * origin even on a page whose Referrer-Policy is no-referrer, which is how fastn knows the widget
 * is live on that customer's product (embed status per customer, docs/services/WIDGETS.md).
 */
export function embedSnippet(): string {
  return `<iframe src="${publicApiBase()}/v1/embed/iframe?token=EMBED_TOKEN" style="width:100%;height:600px;border:none" allow="clipboard-write" referrerpolicy="strict-origin-when-cross-origin"></iframe>`;
}
